import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Grupo {
  cod_grupo_cliente?: number;
  des_grupo_cliente: string;
  desde?: string;
  hasta?: string;
  lun?: boolean;
  mar?: boolean;
  mie?: boolean;
  jue?: boolean;
  vie?: boolean;
  sab?: boolean;
  dom?: boolean;
  usuarios?: any[];
  vehiculos?: any[];
  usuariosCount?: number;
  vehiculosCount?: number;
}

export interface Usuario {
  usuario: string;
  nombre: string;
  isAssigned?: boolean;
  isAdmin?: boolean;
}

export interface Vehiculo {
  cod_vehiculo: number;
  matricula: string;
  isAssigned?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class GruposService {

  private apiUrl = `${environment.baseUrl}admin/grupos`;

  constructor(private http: HttpClient) { }

  /**
   * Obtiene lista de todos los grupos con opción de búsqueda
   */
  getGrupos(search?: string): Observable<any> {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<any>(`${this.apiUrl}`, { params });
  }

  /**
   * Obtiene un grupo específico por ID
   */
  getGrupo(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  /**
   * Crea un nuevo grupo
   */
  createGrupo(grupo: Grupo): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, grupo);
  }

  /**
   * Actualiza un grupo existente
   */
  updateGrupo(id: number, grupo: Grupo): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, grupo);
  }

  /**
   * Elimina un grupo
   */
  deleteGrupo(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }

  /**
   * Obtiene usuarios disponibles para asignar al grupo
   */
  getUsuariosDisponibles(grupoId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${grupoId}/usuarios-disponibles`);
  }

  /**
   * Guarda usuarios asignados al grupo
   */
  saveUsuarios(grupoId: number, data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${grupoId}/usuarios`, data);
  }

  /**
   * Elimina un usuario específico del grupo
   */
  deleteUsuarioFromGrupo(grupoId: number, usuario: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${grupoId}/usuarios/${usuario}`);
  }

  /**
   * Obtiene vehículos disponibles para asignar al grupo
   */
  getVehiculosDisponibles(grupoId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${grupoId}/vehiculos-disponibles`);
  }

  /**
   * Guarda vehículos asignados al grupo
   */
  saveVehiculos(grupoId: number, data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${grupoId}/vehiculos`, data);
  }

  /**
   * Elimina un vehículo específico del grupo
   */
  deleteVehiculoFromGrupo(grupoId: number, cod_equipo_rastreo: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${grupoId}/vehiculos/${cod_equipo_rastreo}`);
  }
}
